import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStateService } from './auth-state.service';

@Injectable({
    providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
    constructor(private authStateService: AuthStateService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (
            request.url.endsWith('/token') ||
            request.url.endsWith('/payment-success/motor') ||
            request.url.endsWith('/payment-success/sme') ||
            request.url.endsWith('/payment-page') ||
            request.url.indexOf('/click-and-pay-payment-look-up') !== -1 ||
            request.url.indexOf('/payment-success/motor') !== -1 ||
            request.url.indexOf('/payment-success/sme') !== -1
        ) {
            return next.handle(request);
        } else {
            const tokenInfo = this.authStateService.getAuthTokenInfo();
            const accessToken = tokenInfo?.['access_token'];

            if (!accessToken) {
                return next.handle(request);
            }

            const modifiedRequest = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            return next.handle(modifiedRequest);
        }
    }
}
